import * as z from 'zod';

export const EventSessionSchema = z.object({
  id: z.string(),
  eventId: z.string(),
  startsAt: z.coerce.date(),
  endsAt: z.coerce.date(),
  label: z.string().max(120).nullish(),
  createdAt: z.coerce.date(),
});

export type EventSessionType = z.infer<typeof EventSessionSchema>;
